import { axiosGet } from '../../../app/Helpers/AxiosHelper';
import { TASK_PROCEDURE } from '../../../app/Config/ApiUrl';

export default {
    state: {
        customFields: [],
        customValues: [],
        contacts: [
                {
                  name: "First Name",
                  fieldKey: "firstName",
                },
                {
                  fieldKey: "lastName",
                  name: "Last Name",
                },
                {
                  fieldKey: "name",
                  name: "Name",
                },
                {
                  fieldKey: "email",
                  name: "Email",
                },
                {
                  fieldKey: "phone",
                  name: "Phone",
                },
                {
                  fieldKey: "address1",
                  name: "Address1",
                },
                {
                  fieldKey: "city",
                  name: "City",
                },
                {
                  fieldKey: "state",
                  name: "State",
                },
                {
                  fieldKey: "postalCode",
                  name: "Postal Code",
                },
                {
                  fieldKey: "website",
                  name: "Website",
                },
                {
                  fieldKey: "source",
                  name: "Source",
                },
                {
                  fieldKey: "country",
                  name: "Country",
                },
                {
                  fieldKey: "companyName",
                  name: "Company Name",
                },
              ],
        lastFetched: null,
        isLoading: false,
        error: null
    },

    getters: {
        customFields: state => state.customFields,
        customValues: state => state.customValues,
        customContacts: state => state.contacts,
        hasCustomFieldsData: state => state.customFields.length > 0 || state.customValues.length > 0,
        shouldRefetchCustomFields: state => {
            if (!state.lastFetched) return true;
            // Refetch if data is older than 5 minutes
            const fiveMinutes = 5 * 60 * 1000;
            return Date.now() - state.lastFetched > fiveMinutes;
        },
        isLoadingCustomFields: state => state.isLoading,
        customFieldsError: state => state.error
    },

    mutations: {
        SET_CUSTOM_FIELDS(state, fields) {
            state.customFields = fields || [];
        },
        
        SET_CUSTOM_VALUES(state, values) {
            state.customValues = values || [];
        },
        
        SET_LAST_FETCHED(state, timestamp) {
            state.lastFetched = timestamp;
        },
        
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
        
        SET_ERROR(state, error) {
            state.error = error;
        },
        
        CLEAR_CUSTOM_FIELDS_DATA(state) {
            state.customFields = [];
            state.customValues = [];
            state.lastFetched = null;
            state.error = null;
        }
    },

    actions: {
        async fetchCustomFieldsData({ commit, state, getters }, forceRefresh = false) {
            // Don't fetch if already loading
            if (state.isLoading) return;
            
            // Don't fetch if we have recent data and not forcing refresh
            if (!forceRefresh && !getters.shouldRefetchCustomFields && getters.hasCustomFieldsData) {
                return;
            }
            
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            
            try {
                // Using the same endpoints as procedureold.vue
                const [custValsResponse, custFieldsResponse] = await Promise.all([
                    axiosGet(`${TASK_PROCEDURE}/customvalues`),
                    axiosGet(`${TASK_PROCEDURE}/customfields`)
                ]);
                
                commit('SET_CUSTOM_VALUES', custValsResponse.data.customValues);
                commit('SET_CUSTOM_FIELDS', custFieldsResponse.data.customFields);
                commit('SET_LAST_FETCHED', Date.now());
            } catch (error) {
                console.error('Error fetching custom fields:', error);
                commit('SET_ERROR', error.message || 'Failed to fetch custom fields');
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        clearCustomFieldsData({ commit }) {
            commit('CLEAR_CUSTOM_FIELDS_DATA');
        }
    }
};